"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "href", "arrow"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".Breadcrumb {\n  margin: 0;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n}\n.Breadcrumb a {\n  color: #0a5ec0;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  margin: 0;\n  text-transform: capitalize;\n  text-decoration: none;\n  transition: ease-in-out 0.15s;\n  white-space: nowrap;\n  overflow-x: none;\n}\n.Breadcrumb a:hover {\n  text-decoration: underline;\n}\n.Breadcrumb__arrow {\n  margin: 0 0.75rem;\n  height: 0.75rem;\n}\n.Breadcrumb:last-child a {\n  color: #424242;\n  cursor: default;\n  pointer-events: none;\n  text-decoration: none;\n}";
  var fileName = "Breadcrumb_Breadcrumb";
  var element = document.querySelector("style[data-sass-component='Breadcrumb_Breadcrumb']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
/* babel-plugin-inline-import '../../assets/icons/icon-right.svg' */
var rightArrow = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDggMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDEzTDcgN0wwLjk5OTk5OSAxIiBzdHJva2U9IiMwQTVFQzAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
var Breadcrumb = function Breadcrumb(_ref) {
  var children = _ref.children,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href,
    arrow = _ref.arrow,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", _objectSpread(_objectSpread({
    className: "Breadcrumb"
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [href ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: href,
        children: children
      }) : {
        children: children
      }, arrow && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: rightArrow,
        className: "Breadcrumb__arrow",
        alt: "Tab"
      })]
    })
  }));
};
var _default = Breadcrumb;
exports["default"] = _default;